import HttpClient from "../../utils/http";

// Merchant Authentication interfaces
export interface MerchantOTPRequest {
  mobileNumber: string;
}

export interface MerchantOTPResponse {
  success: boolean;
  message: string;
  otp_sent: boolean;
}

export interface MerchantVerifyOTPRequest {
  mobileNumber: string;
  otp: string;
}

export interface MerchantLoginResponse {
  success: boolean;
  data?: {
    accessToken: string;
    type: string; // "merchant" type from backend
    merchant_id: string;
    name: string;
    state: string;
  };
  error: null;
}

export interface MerchantProfile {
  merchant_id: string;
  name: string;
  mobile_no: string;
  email: string;
  status: string;
  pincode: number;
  location: string;
  created_at: string;
  updated_at: string;
}


export function sendMerchantOTP(credentials: MerchantOTPRequest): Promise<{ data: MerchantOTPResponse }> {
  const url = `v1/admin/users/merchant/login/generate-otp`;
  return HttpClient.post(url, credentials);
}

export function verifyMerchantOTP(credentials: MerchantVerifyOTPRequest): Promise<{ data: MerchantLoginResponse }> {
  const url = `v1/admin/users/merchant/login/validate-otp`;
  return HttpClient.post(url, credentials);
}

export function getMerchantProfile(): Promise<{ data: { data: MerchantProfile } }> {
  const url = `v1/admin/users/merchant/profile`;
  return HttpClient.get(url);
}

export function merchantLogout(): Promise<{ data: { success: boolean; message: string } }> {
  const url = `v1/admin/users/merchant/logout`;
  return HttpClient.post(url, {});
}
